import PropTypes from 'prop-types';

const CardSourcePropType = PropTypes.shape({
  source: PropTypes.string,
  cardNickname: PropTypes.string,
  lastFourDigits: PropTypes.string,
  expiry: PropTypes.string,
  address: PropTypes.string,
  unitNumber: PropTypes.string,
  city: PropTypes.string,
  province: PropTypes.string,
  postalCode: PropTypes.string
});

export default CardSourcePropType;
